import React, { useEffect, useContext } from 'react';
import { Redirect } from 'react-router-dom'; 

import { DispatchContext } from '../../../context/Provider';

const Logout = (props) => {

    const appDispatch = useContext(DispatchContext);
    const { authDispatch, globalDispatch } = appDispatch;
    
    useEffect(() => {

        globalDispatch({type: 'setClassrooms', value: []});
        authDispatch({type: "logout"});

    }, []);

    return <Redirect to="/login" />;
}

export default Logout;